import { RxCollectionCreator } from 'rxdb';

export const allRigidUserSchema: RxCollectionCreator = {
	schema: {
		title: 'RBDM Rigid User schema',
		description: 'create a RBDM rigid user schema',
		version: 1,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			id: {
				type: 'integer',
			},
			sfid: {
				type: 'string',
				maxLength: 250,
			},
			phone: {
				type: ['string', 'null'],
			},
			name: {
				type: 'string',
			},
			status: {
				type: ['string', 'null'],
			},
			createddate: {
				type: ['string', 'null'],
				format: 'date-time',
			},
			clubname: {
				type: ['string', 'null'],
			},
			contractorclass: {
				type: ['string', 'null'],
			},
			glue_consumption_per_month: {
				type: ['number', 'null'],
			},
			membershipno: {
				type: ['string', 'null'],
			},
			club_mapping: {
				type: ['string', 'null'],
			},
			variable_contractor_type_c: {
				type: ['string', 'null'],
			},
			venuestatus_c: {
				type: ['string', 'null'],
			},
			reason_for_approval_rejection_c: {
				type: ['string', 'null'],
			},
			mdicode: {
				type: ['string', 'null'],
			},
			is_a_ob: {
				type: ['boolean', 'null'],
			},
			contractorconsumption: {
				type: ['string', 'null'],
			},
			kyc_id_proof_verification: {
				type: ['string', 'null'],
			},
			is_zbc: {
				type: ['boolean', 'null'],
			},
			is_de_growing: {
				type: ['boolean', 'null'],
			},
			is_adopted_by: {
				type: ['boolean', 'null'],
			},
			is_disengaged_contractor: {
				type: ['boolean', 'null'],
			},
			priority: {
				type: ['integer', 'null'],
			},
			totalbankingQTD: {
				type: ['number', 'null'],
			},
			pwg_banking_qtd: {
				type: ['number', 'null'],
			},
			visitstatus: {
				type: ['string', 'null'],
			},
			current_quarter_visitstatus: {
				type: ['boolean', 'null'],
			},
		},
		required: ['id', 'sfid', 'name'],
	},
	migrationStrategies: {
		1: async (oldDoc) => {
			return {
				...oldDoc,
				reason_for_approval_rejection_c: oldDoc.reason_for_approval_rejection_c ?? null,
				mdicode: oldDoc.mdicode ?? null,
				is_a_ob: oldDoc.is_a_ob ?? null,
				contractorconsumption: oldDoc.contractorconsumption ?? null,
				is_zbc: oldDoc.is_zbc ?? null,
				is_de_growing: oldDoc.is_de_growing ?? null,
				is_adopted_by: oldDoc.is_adopted_by ?? null,
				is_disengaged_contractor: oldDoc.is_disengaged_contractor ?? null,
				current_quarter_visitstatus: oldDoc.current_quarter_visitstatus ?? null,
			};
		},
	},
};
